const data = {
    terms: [
    {
            "term": "Administration",
            "description": "Administration refers to the period of time during which a particular leader governs or the group of officials who govern under that leader."
        },
        {
            "term": "Advisor",
            "description": "An advisor is a person who gives advice in a particular field."
        },
        {
            "term": "Ally",
            "description": "An ally is a group or person who supports and works with another."
        },
        {
            "term": "Ambassador",
            "description": "An ambassador is a high-ranking diplomatic official stationed in a foreign country (or colony) to represent their home nation's interests, promote diplomatic relations, and assist citizens abroad."
        },
        {
            "term": "Ancestry",
            "description": "Ancestry is a family history or background."
        },
        {
            "term": "Anglican",
            "description": "The Anglican Church was created under King Henry VIII during the Reformation and became the official church of England."
        },
        {
            "term": "Assembly",
            "description": "The Maryland Assembly was a gathering of freemen to debate the laws of the colony."
        },
        {
            "term": "Attorney General",
            "description": "An attorney general is the chief legal officer and top law enforcement official for a government, providing legal advice, representing the state or federal government in litigation, and overseeing legal matters."
        },
        {
            "term": "Authority",
            "description": "Authority refers to the legitimate power, right, or authorization to command, make decisions, control actions, or influence others."
        },
        {
            "term": "Blasphemy",
            "description": "Blasphemy is the act or offense of speaking badly about God or sacred things."
        },
        {
            "term": "Burgess",
            "description": "In American colonial history, a burgess referred to a representative in the lower house of the legislature in Maryland or Virginia"
        },
        {
            "term": "Capsize",
            "description": "Capsize refers to turning a boat or vessel upside down or on its side while in the water, often due to high winds, large waves, overloading, or loss of stability."
        },
        {
            "term": "Cash Crop",
            "description": "A cash crop is an agricultural product grown specifically to be sold for profit in markets or for export, rather than for consumption by the farmer or their local community."
        },
        {
            "term": "Catholic",
            "description": "A Catholic is a Christian who belongs to the Roman Catholic Church, led by the Pope."
        },
        {
            "term": "Catholic Mass",
            "description": "Catholic Mass is the central act of worship in the Catholic Church where bread and wine become the body and blood of Jesus Christ."
        },
        {
            "term": "Chancellor",
            "description": "A chancellor is a high-ranking official title used across government, education, law, and religion. The role varies heavily by region."
        },
        {
            "term": "Chapel",
            "description": "A chapel is a small place of worship for Christians."
        },
        {
            "term": "Charter",
            "description": "A charter is a document that gives legal permission to claim land."
        },
        {
            "term": "Chieftains",
            "description": "A chieftain is the head or leader of a “tribe or clan.”"
        },
        {
            "term": "Citizenship",
            "description": "Citizenship refers to the legal status of being a recognized member of a state or nation, granting individuals specific rights, privileges, and protections."
        },
        {
            "term": "Colony",
            "description": "A colony is a country or area under the full or partial political control of another country, typically a distant one, and occupied by settlers from that country."
        },
        {
            "term": "Colonization",
            "description": "Colonization is the process by which people from one country settle in and control a new land."
        },
        {
            "term": "Commission",
            "description": " A commission is a group of people appointed to complete a job or study a public issue for the government."
        },
        {
            "term": "Commissioner",
            "description": "A commissioner is an official in charge of a government department, agency, or a member of a commission, often holding significant administrative or judicial authority."
        },
        {
            "term": "Common Council",
            "description": "Common Council refers to the local legislative body of a town’s government or, in some contexts, the lower branch of a city’s bicameral governing structure."
        },
        {
            "term": "Consent",
            "description": "Consent means giving permission."
        },
        {
            "term": "Conversion",
            "description": "Conversion means to change one's religion or beliefs."
        },
        {
            "term": "Councilor",
            "description": "A councilor is an elected or appointed member of a governing council, typically at the local government level, such as a city or town."
        },
        {
            "term": "Creditor",
            "description": "A creditor is an individual, organization, or government entity that lends money expecting it to be paid back with interest, or the cost of borrowing money."
        },
        {
            "term": "Diplomacy",
            "description": "Diplomacy is the practice of building and maintaining relationships between nations or governments."
        },
        {
            "term": "Discrimination",
            "description": "Discrimination refers to the unfair or prejudicial treatment of individuals or groups based on characteristics such as race, gender, age, religion, or sexual orientation."
        },
        {
            "term": "Dispute",
            "description": "A dispute is a formal disagreement, controversy, or conflict of claims between parties, often involving legal, financial, or personal issues."
        },
        {
            "term": "Enslaved",
            "description": "Enslaved means to be kept and forced to work without payment and against one’s will. Over the course of the 17th century, slavery would become based on a person’s race."
        },
        {
            "term": "Executed",
            "description": "Executed refers to a person being killed as punishment for a crime, following a formal legal sentence."
        },
        {
            "term": "Expedition",
            "description": "An expedition is an organized journey or voyage undertaken by a group of people for a specific purpose."
        },
        {
            "term": "Indentured servant ",
            "description": "An indentured servant was an individual, commonly in the 17th–19th centuries, who signed a contract (indenture) to work without wages for a master for a fixed period—typically four to seven years—in exchange for passage to a new country (usually American colonies), food, clothing, and shelter."
        },
        {
            "term": "Indigenous",
            "description": "Indigenous people are the first people living in a place."
        },
        {
            "term": "Investor",
            "description": "An investor is someone who gives money to someone or something, hoping to make that money and more back."
        },
        {
            "term": "Jesuit",
            "description": "A Jesuit is a member of the Society of Jesus, a Roman Catholic religious order."
        },
        {
            "term": "Legacy",
            "description": "A legacy is the lasting impact, values, and memories a person leaves behind."
        },
        {
            "term": "Liberty of conscience",
            "description": "Liberty of conscience means the freedom to decide for yourself what is right and wrong."
        },
        {
            "term": "Lineage",
            "description": "Lineage refers to a direct line of descent from a common ancestor. It encompasses a person's family history—including both those who came before them and their descendants."
        },
        {
            "term": "Maryland Assembly",
            "description": "After the 1650 split into two legislative bodies, the Maryland Assembly was made up of representatives who reflected the"
        },
        {
            "term": "Migrating",
            "description": "Migrating refers to the movement of people from one place or region to another, often for settlement."
        },
        {
            "term": "Militia",
            "description": "Militia is the military force that is raised from the civil population to supplement a regular army in an emergency."
        },
        {
            "term": "Nacotchtank (Anacostan)",
            "description": "The Nacotchtank were a Indigenous tribe who lived near the Potomac River around what is now Washington, D.C.. By the late 17th century, they were absorbed by the Piscataway."
        },
        {
            "term": "Naturalized",
            "description": "Someone who is naturalized is a foreign-born person who has legally acquired the nationality of a country after birth."
        },
        {
            "term": "Negotiators",
            "description": " negotiator is a person who works with others to reach an agreement, solve a problem, or settle a disagreement, often by finding a middle ground."
        },
        {
            "term": "Pardon",
            "description": "ardon is the official act of a government authority of forgiving someone for a crime and releasing them from punishment."
        },
        {
            "term": "Parliament",
            "description": "Parliament is a country's supreme legislative (law-making) body. It is primarily responsible for making and changing laws, debating important public issues, and overseeing the actions of the executive government."
        },
        {
            "term": "Passage",
            "description": "A passage is a journey or travel of a vessel from one location to another, typically across open water, between specific ports, or across oceans."
        },
        {
            "term": "Patawomeke (Potomac)",
            "description": "The Patawomeke are an Indigenous tribe in Maryland who in the 17th century lived south of the Potomac River."
        },
        {
            "term": "Patent",
            "description": "A patent is the initial, highest-level legal document conveying ownership of public land from the federal or state government to a private party."
        },
        {
            "term": "Persecution",
            "description": "Persecution is the cruel or unfair treatment of an individual or group, especially because of their beliefs, identity, or membership in a particular group."
        },
        {
            "term": "Persecution",
            "description": "Persecution is the cruel or unfair treatment of an individual or group, especially because of their beliefs, identity, or membership in a particular group."
        },
          {
            "term": "Persecution",
            "description": "Persecution is the cruel or unfair treatment of an individual or group, especially because of their beliefs, identity, or membership in a particular group."
        },
     {
    "term": "Petition",
    "description": "A petition is a formal, written request to the court asking for a specific legal action."
  },
  {
    "term": "Piscataway",
    "description": "The Piscataway are an Indigenous nation located in Southern Maryland."
  },
  {
    "term": "Plantation",
    "description": "A plantation is a large-scale agricultural estate, typically located in tropical or subtropical regions, dedicated to growing a single cash crop."
  },
  {
    "term": "Proprietor",
    "description": "A proprietor is the person who owns the title to a piece of land or colony. This title would give them full legal ownership and the authority to govern the land."
  },
  {
    "term": "Protestant",
    "description": "A Protestant is a Christian who belongs to a branch of Christianity that separated from the Roman Catholic Church in the 1500s. They believe the Bible is the final authority on how to live and behave. Baptists, Methodists, and Lutherans are all Protestants."
  },
  {
    "term": "Puritans",
    "description": "A Puritan is a 16th and 17th-century English Protestant who sought to \"purify\" the Church of England of Roman Catholic practices, advocating for strict moral codes, piety, and reduced ceremonial worship."
  },
  {
    "term": "Quaker",
    "description": "A Quaker is a member of the Religious Society of Friends, a historically Christian movement founded in 17th-century England. They believe in a direct, inward connection to the Divine in every person and are known for their commitment to pacifism, simplicity, and social equality."
  },
  {
    "term": "Religious Freedom",
    "description": "Religious freedom is the right to practice one’s religion without interference."
  },
  {
    "term": "Secretary of State",
    "description": "A Secretary of State acts as an advisor to a leader and handles diplomacy and foreign affairs."
  },
  {
    "term": "Susquehannocks",
    "description": "The Susquehannocks are an Indigenous tribe located in Central Maryland and the Eastern Shore."
  },
  {
    "term": "Tayac (TIE-ack)",
    "description": "The tayac is the most powerful chief in the area; the chief of all village and clan chiefs."
  },
  {
    "term": "Territory",
    "description": "A territory is a specific area of land, water, or space that is under the control, ownership, or protection of a person, group, or government."
  },
  {
    "term": "Tolerate",
    "description": "Tolerate means to allow, endure, or put up with something."
  },
  {
    "term": "Toleration",
    "description": "Toleration is the deliberate choice by individuals, communities, or governments to refrain from interfering with or persecuting religious practices and beliefs they disagree with or internally disapprove of."
  },
  {
    "term": "Treason",
    "description": "Treason is the crime of betraying one's country by attempting to overthrow the government, waging war against it, or aiding its enemies."
  },
  {
    "term": "Treasurer",
    "description": "A treasurer is an officer entrusted with the receipt, care, and disbursement of funds for a government, business, or organization."
  },
  {
    "term": "Unprecedented",
    "description": "Unprecedented refers to something that has never happened, been known, or been done before."
  },
  {
    "term": "Voyage",
    "description": "A voyage is a long, often adventurous journey, typically taken by water."
  },
  {
    "term": "Werowance",
    "description": "A werowance is a village leader in the Renape dialect of Algonkian found in Virginia and Maryland’s Eastern Shore."
  },
  {
    "term": "Yaocomico",
    "description": "The Yaocomico were an Indigenous subtribe related to the Piscataway. They resided on the north bank of the Potomac River, and were absorbed by the Piscataway in the 17th century."
  }
]
}

export default data;